.container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /*
    #root is isolated, so app content can't out-stack this body-level portal. This small z-index is
    only to sit above the react-modal overlay, a later <body> sibling that uses z-index: auto.
  */
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-top: 16px;
  /* let clicks fall through the gaps between toasts to the page below */
  pointer-events: none;
}

.item {
  pointer-events: auto;
}

.entering {
  animation: toast-in 300ms ease forwards;
}

.leaving {
  animation: toast-out 250ms ease forwards;
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(-24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes toast-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-24px);
  }
}
